import { Box, Container, Typography } from "@mui/material";
import React, { useState } from "react";
import DownloadApps from "../components/DownloadApps";
import OurPartners from "../components/OurPartners";
import RoleSelectCards, { FAQ_PATH_BY_ROLE } from "../components/RoleSelectCards";
import SignupModal from "../components/SignupModal";
import { Reveal } from "../theme/animation";
import type { Testimonial } from "../content/roleFaqsContent";

export const TESTIMONIALS: Testimonial[] = [
    {
        quote: "Something like SMSP which prepares kids to be mentally strong along with being physically prepared has been the missing link.",
        author: "B. Steele",
        role: "Athletic Director"
    },
    {
        quote: "I love this site and the Bell family is excited to have this resource ready for our young athlete.",
        author: "K. Bell",
        role: "Guardian of student athlete"
    },
    {
        quote: "In my previous work as an educator I often wished student athletes had access to resources like these to help them perform at their best while truly enjoying the sport they are involved in.",
        author: "G. Gordon",
        role: "Guardian of student athlete / Former Educator"
    },
    {
        quote: "My daughter quit basketball during COVID and could have used this program to boost her confidence during that isolated time.",
        author: "C. Johnson",
        role: "Guardian of student athlete"
    },
    {
        quote: "Super valuable for the kids. Belief is where it starts and I could have made it a lot further in the game if I wasn't in my head.",
        author: "Anonymous",
        role: "High School Basketball Coach"
    }
];

/**
 * Shared body content for both HomeSmsp and HomeWhiteLabel (Why it Works, Select your role, Testimonials, Final CTA).
 */
const HomePageBody: React.FC = () => {
    const [signupModalOpen, setSignupModalOpen] = useState(false);

    return (
        <>
            <DownloadApps />

            <Box id="select-your-role" sx={{ py: 8, bgcolor: "primary.main", color: "white" }}>
                <Container maxWidth="lg">
                    <Reveal variant="fadeUp">
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{ textAlign: "center", mb: 4, fontWeight: "bold", fontStyle: "italic" }}
                        >
                            Select your role below to explore your path
                        </Typography>
                    </Reveal>
                    <RoleSelectCards pathByRole={FAQ_PATH_BY_ROLE} />
                </Container>
            </Box>

            <OurPartners />

            <SignupModal open={signupModalOpen} onClose={() => setSignupModalOpen(false)} />
        </>
    );
};

export default HomePageBody;
